
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.435 10.774h.132c1.214-.02 2.195-.447 2.92-1.263 1.594-1.797 1.329-4.877 1.3-5.171-.104-2.207-1.147-3.263-2.009-3.756C10.137.215 9.388.017 8.551 0H8.48c-.46 0-1.362.075-2.227.567-.87.493-1.93 1.549-2.034 3.773-.029.294-.294 3.374 1.3 5.171.721.816 1.703 1.243 2.916 1.263zm-3.11-6.33c0-.013.004-.026.004-.034.137-2.969 2.244-3.288 3.147-3.288h.05c1.118.025 3.019.48 3.147 3.288 0 .012 0 .025.004.033.004.029.294 2.845-1.023 4.327-.521.588-1.217.878-2.132.886H8.48c-.912-.008-1.611-.298-2.129-.886C5.038 7.296 5.32 4.468 5.324 4.443z"}}),_c('path',{attrs:{"d":"M17.01 15.884v-.012c0-.033-.004-.067-.004-.104-.025-.82-.078-2.737-1.876-3.35l-.041-.012c-1.867-.476-3.42-1.553-3.437-1.565a.558.558 0 10-.642.915c.07.05 1.719 1.196 3.78 1.726.966.344 1.073 1.375 1.102 2.32 0 .037 0 .07.004.103.005.372-.02.948-.086 1.28-.671.38-3.3 1.697-7.3 1.697-3.984 0-6.63-1.32-7.305-1.702-.066-.331-.095-.907-.087-1.28 0-.033.004-.066.004-.103.03-.944.137-1.975 1.102-2.319 2.062-.53 3.71-1.68 3.78-1.726a.558.558 0 10-.642-.916c-.016.013-1.56 1.09-3.437 1.566l-.04.012c-1.798.617-1.852 2.534-1.877 3.35 0 .037 0 .07-.004.103v.013c-.004.215-.008 1.32.211 1.876a.531.531 0 00.216.26c.124.083 3.101 1.98 8.082 1.98 4.982 0 7.959-1.9 8.083-1.98a.554.554 0 00.216-.26c.207-.551.202-1.657.198-1.872z"}})])
          )
        }
      }
    